var adminIdList=["7rGQI8CmvKh4CxvNa7CuSvovw7V2","AxDC6GjRg7bsl0ItO7WkL0Jdg4s1"];

const config = {
  apiKey: "AIzaSyAQdrTXhcTH_1iYJszXbI3mGziYy7LyAks",
  authDomain: "csavar-go.firebaseapp.com",
  databaseURL: "https://csavar-go.firebaseio.com",
  projectId: "csavar-go",
  storageBucket: "csavar-go.appspot.com",
  messagingSenderId: "831209682604",
  appId: "1:831209682604:web:77cced5da3f707ca7a5109",
  measurementId: "G-CB60TT2TYV"
};

function firebaseConfig() {
	return config;
}

function getAdminIdList() {
	return adminIdList;
}

function isAdmin(id){
    for (var i in adminIdList) {
         if (adminIdList[i] ==id) return true;
    }
    return false;
}

export {
	firebaseConfig,
    getAdminIdList,
    isAdmin
}